"use client";
import React, { useEffect, useState } from "react";
import styles from "./LoadingModule.module.css";
import { ThreeDots } from "react-loader-spinner";
import LoadingAnimation from "../../../components/atoms/LoadingAnimation";

const useAnimateText = (steps: string[], rate: number) => {
  const [text, setText] = useState("");

  useEffect(() => {
    let stepIndex = 0;
    let dotCount = 0;

    const intervalTime = rate / 4;

    const intervalId = setInterval(() => {
      dotCount = (dotCount + 1) % 4;

      if (dotCount === 0) {
        stepIndex = (stepIndex + 1) % steps.length;
      }

      const dots = ".".repeat(dotCount);
      setText(`${steps[stepIndex]}${dots}`);
    }, intervalTime);

    return () => clearInterval(intervalId);
  }, [steps, rate]);

  return text;
};

const LoadingModule = ({
  messages,
  iterationSpeed = 3800,
}: {
  messages: string[];
  iterationSpeed?: number;
}) => {
  const text = useAnimateText(messages || ["Loading"], iterationSpeed);
  return (
    <div className={styles.container}>
      <div style={{ width: "112px", height: "112px" }}>
        <LoadingAnimation />
      </div>
      <h3>{text}</h3>
    </div>
  );
};

export default LoadingModule;
